module.exports = __webpack_public_path__ + "static/media/DomesticViolence.790210c8.svg";